/**
 * @prettier
 * @flow
 */
import isString from 'lodash/isString';

export function trim<T>(value?: ?T): T {
    // TODO: Return maybe type
    if (value === undefined || value === null) {
        return (value: any);
    }
    if (!isString(value)) {
        return value;
    }
    return (value: any).trim();
}
